// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9c778c47","453":"23fd03ae","553":"d2b56479","977":"08b06e6a"}[chunkId] + ".chunk.js";
};